<template>
  <div class="edis-osago">
    <div class="row">
      <div class="col-md-6 mb-2">
        <label>Серия</label>
        <IMaskComponent
          v-model="data.series"
          type="text"
          class="form-control"
          :mask="'[aaa]'"
          :prepare="str => str.toUpperCase()"
          placeholder="AAA"
          required
        />
      </div>
      <div class="col-md-6 mb-2">
        <label>Номер</label>
        <IMaskComponent
          v-model="data.number"
          type="text"
          class="form-control"
          :mask="'[0000000000]'"
          placeholder="01234567890"
          required
        />
      </div>
      <div class="col-md-6 mb-2">
        <label>Дата начала</label>
        <input
          v-model="data.date_start"
          type="date"
          class="form-control"
          required
        >
      </div>
      <div class="col-md-6 mb-2">
        <label>Дата окончания</label>
        <input
          v-model="data.date_end"
          type="date"
          class="form-control"
          required
        >
      </div>
    </div>
  </div>
</template>

<script>
const type = 'osago'

export default {
  name: 'DocumentOsagoEdit',
  props: {
    documentData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      data: {
        series: '',
        number: '',
        date_start: '',
        date_end: ''
      }
    }
  },
  watch: {
    data: {
      handler () {
        this.update()
      },
      deep: true
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
    this.update()
  },
  methods: {
    update () {
      this.$emit('update', {
        type: type,
        data: this.data
      })
    }
  }
}
</script>

<style scoped>
  .edis-osago input {
    margin-bottom: 5px;
  }
  .edis-osago textarea {
    margin-bottom: 5px;
  }
</style>
